import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Button2.css';
import { BarChart, Users, UserCheck, MapPin, BookOpenCheck } from 'lucide-react';

const CustomButton = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isHovered, setIsHovered] = useState(false);
  const [showTeamViewDefinition, setShowTeamViewDefinition] = useState(false);

  const isActive = (path) => location.pathname === path;

  return (
    <>
      <div className="button2-container">
        <div
          className={`custom-card-button state ${isActive('/state-view') ? 'active' : ''}`}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={() => navigate('/state-view')}
        >
          <MapPin className="icon" />
          <span>Project Achievement View</span>
        </div>

        <div
          className={`custom-card-button ${isActive('/summary') ? 'active' : ''}`}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={() => navigate('/summary')}
        >
          <BarChart className="icon" />
          <span>View Employee Summary</span>
        </div>

        <div
          className={`attractive-card-button ${isHovered ? 'hover' : ''} ${isActive('/all-view') ? 'active' : ''}`}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={() => navigate('/all-view')}
        >
          <UserCheck className="icon" />
          <span>View Individual Performance</span>
        </div>

        <div
          className={`custom-card-button alt ${isActive('/team-view') ? 'active' : ''}`}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={() => navigate('/team-view')}
        >
          <Users className="icon" />
          <span>Team View</span>
        </div>

        <div
          className={`custom-card-button definition-button`}
          onClick={() => setShowTeamViewDefinition(true)}
        >
          <BookOpenCheck className="icon" />
          <span>Definition</span>
        </div>
      </div>

      {/* Team View Definition Modal */}
      {showTeamViewDefinition && (
        <div className="definition-overlay">
          <div className="definition-box">
            <button className="close-button" onClick={() => setShowTeamViewDefinition(false)}>×</button>
            <h2>Key Definitions - Team View</h2>

            <table className="definition-table">
              <tbody>
                <tr>
                  <th>PID</th>
                  <td>Choose the project ID you want to view data for.</td>
                </tr>
                <tr>
                  <th>Manager Name</th>
                  <td>Select the manager's name to view data specific to that user.</td>
                </tr>
                <tr>
                  <th>Achievement</th>
                  <td>
                    Shows project-wise and employee-wise data, including:<br />
                    <strong>Start Date:</strong> The date when the employee was allocated to the project.<br />
                    <strong>End Date:</strong> The date when the employee was unassigned from the project.<br />
                    <strong>Achievement (BR):</strong> The cumulative number of applications completed by the employee within the project (Benefit received applications).<br />
                    <strong>Note:</strong> If the employee is still active on the project, the End Date is automatically recorded as yesterday's date (today - 1).
                  </td>
                </tr>
                <tr>
                  <th>Hierarchy</th>
                  <td>
                    Shows the team hierarchy in a tree structure from Delivery Head to Fellow level. For the selected project, it displays the complete hierarchy for each Org mapped to that project, allowing visibility into team structures across multiple orgs.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
    </>
  );
};

export default CustomButton;
